import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showPage(event) {
    const targetPage = event.target.dataset.page
    
    // すべてのページを非表示
    document.querySelectorAll('.company-list').forEach(list => {
      list.classList.add('hidden')
    })
    
    // 対象ページを表示
    const targetList = document.querySelector(`[data-page="${targetPage}"]`)
    if (targetList) {
      targetList.classList.remove('hidden')
    }
    
    // ページネーションボタンの状態更新
    document.querySelectorAll('[data-action="click->pagination#showPage"]').forEach(button => {
      if (button.dataset.page === targetPage) {
        button.classList.remove('bg-white', 'text-gray-700', 'hover:bg-gray-100')
        button.classList.add('bg-blue-600', 'text-white')
      } else {
        button.classList.remove('bg-blue-600', 'text-white')
        button.classList.add('bg-white', 'text-gray-700', 'hover:bg-gray-100')
      }
    })
  }
}
